import React from 'react'
import brower from 'src/helper/brower'
import { history } from 'src/core/router'
import { setDocumentTitle, isRtl } from 'src/helper/tool'
import './index.less'
import { getlangV2, setlang } from 'src/helper/getlang'
import lang from '../lang'
import hybridRouter from 'src/core/hybrid-router'
import config from 'src/core/config'
import jump from 'src/helper/jumpToApp'

const { appLink } = jump
const { vocaAPK } = appLink
export default class extends React.Component {
  state = {
    lang: lang.en,
    language: 'en',
    hostHybrid: config.hostHybrid
  }

  constructor(props) {
    super(props)
    setDocumentTitle(`Yayya - voca chat app`)
  }
  /**
   * @description 跳转PC
   */
  goPC() {
    const isApp = !brower.isIphone() && !brower.isAndroid() && !brower.isWeixin()
    if (isApp) {
      let map = {
        pathname: `/voca-home/pc`
      }

      if (this.state.code && this.state.code !== '') {
        map.query = {
          code: this.state.code,
          activity: this.props.location.query.activity
        }
      }

      history.push(map)
    }
  }

  async componentWillMount() {
    this.goPC()
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language, lang)
    this.setState(
      {
        lang: setlang(language, lang),
        language
      },
      () => {
        setDocumentTitle(this.state.lang.title)
      }
    )

    const favicon = document.querySelector('link[rel="icon"]')
    favicon.href = '/img/favicon_ico_new.png'
  }

  /**
   * @description 充值跳转
   */
  handleRecharge() {
    // history.push('/app/recharge')
    window.location.href = this.state.hostHybrid + hybridRouter.recharge
  }

  render() {
    const { lang, language } = this.state

    return (
      <div className={`voca-mobile ${isRtl(language) ? 'rtl' : ''}`}>
        <div className="video-background">
          <video autoPlay muted loop id="myVideo">
            <source src="https://d2180mnhafnhva.cloudfront.net/fd1cd73c0936acb5bd484e737e95d977.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="page-hd">
          <span className="btn-wrap" onClick={() => this.handleRecharge()}>
            {lang.recharge}
          </span>
        </div>
        <div className="page-cont">
          <div className="logo-wrap">
            <div className="img-wrap">
              <img src="/img/voca-home/logo@2x.webp" />
            </div>
            <div className="text-wrap">
              <h1>voca</h1>
              <p>{lang.subTitle2}</p>
            </div>
          </div>

          <div className="video-wrap">
            <img src="/img/voca-home/voca-app@2x.webp" />
          </div>
        </div>
        <div className="page-ft">
          <div className="logo-wrap">
            <div className="img-wrap">
              <img src="/img/voca-home/logo@2x.webp" alt="" />
            </div>
            <div className="text-wrap">
              <h2>Voca</h2>
              <p>{lang.subTitle}</p>
            </div>
          </div>
          <div className="btn-wrap">
            <a className="btn-item" download={'voca'} href={vocaAPK}>
              {lang.download}
            </a>
          </div>
        </div>
        <div className="copyright">
          Copyright ©2025 Voca HABI TECHNOLOGY LIMITED UNIT D18,3/F WONG KING INDBLDG NO.2-4 TAI YAU ST SAN POKONG
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/voca-home/mobile/index.js